<script setup>
import { computed } from 'vue'
import { useTranslaterStore }   from '@/stores/translater'
import UTACarUsersGroups        from '@/components/car/UTACarUsersGroups.vue'
import UTACarGroups             from '@/components/car/UTACarGroups.vue'
import UTACarUsers              from '@/components/car/UTACarUsers.vue'

const translaterStore = useTranslaterStore()
const getTranslate = computed(() => translaterStore.getTranslate)

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})
</script>

<template>
    <div class="uta-car-rights">

        <header class="uta-header" role="heading" aria-level="1">
            <h1 class="uta-header__title">{{ getTranslate.CAR_RIGHTS }}</h1>
        </header>

        <!-- Группы пользователей, привязанные к автомобилю -->
        <UTACarUsersGroups :uuid="props.uuid" /> 

        <!-- Группы, к которым привязан автомобиль автомобиля -->
        <UTACarGroups :uuid="props.uuid" />

        <!-- Пользователи, привязанные к автомобилю напрямую -->
        <UTACarUsers :uuid="props.uuid" />

    </div>
</template>